import { defineStore } from 'pinia'

import { RemovableRef, useStorage } from '@vueuse/core'

export type ObjMunicipio = {
  idmunicipio: string
  uf: string
  nome: string
}

type State = {
  municipios: RemovableRef<ObjMunicipio[]>
  idunidade: RemovableRef<string>
  unidade: RemovableRef<string>
  cookies: RemovableRef<boolean>
  birdSessionToken: RemovableRef<string>
  birdSessionTokenExpiry: RemovableRef<number>
  hubCpfCnpj: RemovableRef<string>
  enviroment?: RemovableRef<'DEV' | 'HOM' | 'PROD'>
}

const BIRD_SESSION_TOKEN_LIFETIME = 3 * 60 * 60 * 1000 // 3 horas

export const STATE_DEFAULT = {
  idunidade: '',
  unidade: '',
  municipios: [],
  ufs: [],
  pass: '',
  cookies: true,
  birdSessionToken: '',
  birdSessionTokenExpiry: 0,
  hubCpfCnpj: '',
}

export const useMainStore = defineStore('main', {
  state: () =>
    ({
      idunidade: useStorage('idunidade', ''),
      unidade: useStorage('unidade', ''),
      cookies: useStorage('cookies', false),
      birdSessionToken: useStorage('birdSessionToken', '', sessionStorage),
      birdSessionTokenExpiry: useStorage(
        'birdSessionTokenExpiry',
        0,
        sessionStorage,
      ),
      hubCpfCnpj: useStorage('hubCpfCnpj', '', sessionStorage),
      enviroment: undefined,
    }) as State,

  getters: {
    getValidBirdSessionToken(): string {
      const now = Date.now()
      if (
        this.birdSessionToken &&
        this.birdSessionTokenExpiry &&
        now < this.birdSessionTokenExpiry
      ) {
        return this.birdSessionToken
      }
      return ''
    },
  },
  actions: {
    fetchEnviroment() {
      const { hostname } = window.location
      if (hostname.includes('localhost')) {
        this.enviroment = 'DEV'
        return
      }

      if (hostname.includes('dev')) {
        this.enviroment = 'DEV'
        return
      }
      if (hostname.includes('hom')) {
        this.enviroment = 'HOM'
        return
      }

      this.enviroment = 'PROD'
    },
    setUnidade(unidade: string) {
      this.unidade = unidade
    },
    setUnidadeId(unidadeId: string) {
      this.unidade = unidadeId
    },
    setBirdSessionToken(token: string) {
      this.birdSessionToken = token
      if (token && token.trim() !== '') {
        this.birdSessionTokenExpiry = Date.now() + BIRD_SESSION_TOKEN_LIFETIME
      } else {
        this.birdSessionTokenExpiry = 0
      }
    },
    setHubCpfCnpj(value: string) {
      this.hubCpfCnpj = value
    },
    clearBirdSessionToken() {
      this.birdSessionToken = ''
      this.birdSessionTokenExpiry = 0
      this.hubCpfCnpj = ''
    },
    clearData() {
      this.$state = {
        ...STATE_DEFAULT,
        cookies: this.cookies,
      }
    },
  },
})
